import React from 'react';
import Header from './../../Header';
import Footer from './../../Footer';
import Loader from './../../Loader';
import Menu from './../../Menu';
import List from './List';
import ProjectNav from './../ProjectNav';
import { fetchMenu } from "./../../../actions/menuActionCreators";
import { fetchProjects } from "./../../../actions/projectActionCreators";
import { fetchOptions } from "./../../../actions/optionActionCreators";
import ReactFullpage from '@fullpage/react-fullpage';
import { Helmet } from 'react-helmet';
import ReactGA from 'react-ga';

class Index extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            pageLoading: true
        }
    }
    componentDidMount() {
        let {slug} = this.props.match.params;
		ReactGA.pageview('/projects/'+slug);
        Promise.all([
            this.props.dispatch(fetchMenu('menu')),
            this.props.dispatch(fetchProjects()),
            this.props.dispatch(fetchOptions()),
        ]).then(() => {
            this.setState({
                pageLoading: false
            })
        });
    }

    render() {
        let _this = this;
		let { menu } = this.props.menu;

		// const Fullpage = () => (
        //     <ReactFullpage
        //         scrollOverflow={true}
        //         licenseKey={process.env.REACT_APP_FULLPAGE_LICENSE}
        //         render={({ state, fullpageApi }) => {
        //             return (
        //                 <ReactFullpage.Wrapper>
        //                     <List {..._this.props} />
        //                     <Footer {...this.props}  />
        //                 </ReactFullpage.Wrapper>
        //             );
        //         }}
        //     />
		// );
	
		return (
			<div className="fullW">
                <Helmet>
                    <title>Lelay Architects | Projects</title>
                </Helmet>
                <Header {...this.props} bgColor={'#fff'} />
                <section className="ll__projects-category-filter">
                    <ProjectNav {...this.props} />
                </section>
				<main className="ll__projects-category">
					{this.state.pageLoading &&
						<Loader />
					} 
					{/* <Fullpage {...this.props} /> */}
                    <List {..._this.props} />
                    <Footer {...this.props}  />
				</main>
                {menu.primary &&
                    <Menu {...this.props} />
                }
			</div>
		);
    }
}

export default Index;


// WEBPACK FOOTER //
// ./src/components/Projects/Category/index.js